import React from "react";
import iconArrow from "../../assets/benefits/icon-arrow.svg";
import Animate from "../Animate";

const Benefits = ({ t, benefits }) => (
  <div id="benefits" className="landing-container-benefits">
    <div className="landing-layout">
      <div className="landing-page-benefits">
        <div className="landing-list-header">
          <Animate>
            <h2 className="landing-section-title">{t("landing.benefits.title")}</h2>
          </Animate>
          <p className="landing-section-text">{t("landing.benefits.subtitle")}</p>
        </div>
        <div className="landing-benefits">
          {benefits.map(({ text }, index) => (
            <div className="landing-benefits-content" key={index}>
              <img src={iconArrow} alt="" />
              <p>{text}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  </div>
);

export default Benefits;
